import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Copyright from './Copyright';
import SideMenu from './SideMenu';

function Layout() {
    const [collapsed, setCollapsed] = useState(false)
    const [resMenuToggle, setResMenuToggle] = useState(false);
    return (
        <>
            <main>
                <Header collapsed={collapsed} setCollapsed={setCollapsed} resMenuToggle={resMenuToggle} setResMenuToggle={setResMenuToggle} />
                <div className="flex flex-row flex-nowrap">
                    <SideMenu collapsed={collapsed} setCollapsed={setCollapsed} resMenuToggle={resMenuToggle} setResMenuToggle={setResMenuToggle} />
                    <div className="col ps-4 bg-[#f0f2f5] p-4 relative xl:-mt-6 z-20 sm:rounded-xl">
                        <div className="h-[calc(100vh-188px)] overflow-y-auto rounded-xl">
                            <Outlet />
                        </div>
                    </div>
                </div>
                <Copyright />
            </main>
        </>
    );
}

export default Layout;